import HistoryCarousel from "./HistoryCarousel";

export default HistoryCarousel;
